import { chameleonWidget } from './Widget.definition';
import { chameleonSvg } from '../Svg';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonWidget({ prefix }), chameleonTypography({ prefix }), chameleonSvg({ prefix }), chameleonIconButton({ prefix }));
}
